'use client';

import { TrophyIcon, UsersIcon, ClockIcon, ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/20/solid';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const features = [
  {
    name: 'Coaching for All Ages',
    description: 'Friendly and professional coaching for both kids and adults to excel in badminton.',
    icon: UsersIcon,
  },
  {
    name: 'Open 24/7',
    description: 'Practice anytime, day or night. Our courts are always available for passionate players.',
    icon: ClockIcon,
  },
  {
    name: 'Tournaments & Events',
    description: 'Competitions and leagues to help you improve and challenge yourself.',
    icon: TrophyIcon,
  },
  {
    name: 'Community & Social Networking',
    description: 'Connect with fellow players, join events, and build lasting friendships.',
    icon: ChatBubbleOvalLeftEllipsisIcon,
  },
];

const images = [
  '/about_image.jpg',  // Existing image
  '/about_image2.jpg',
];

export default function About() {
  return (
    <section id="about" className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pt-4 lg:pr-8">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold text-indigo-600">About Us</h2>
              <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                Unleash Your Potential
              </p>
              <p className="mt-6 text-lg text-gray-600">
                At Pavan's Badminton Academy, we provide training for both Adults and Kids, top-tier courts, and a motivating environment for players of all skill levels. Whether you are a beginner or a pro, we help you reach the next level.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon aria-hidden="true" className="absolute top-1 left-1 size-5 text-indigo-600" />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>

          {/* Image Slider with Fixed Height */}
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            className="sm:h-auto lg:h-100 md:h-100 w-full sm:max-w-md md:max-w-lg lg:max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10"
          >
            {images.map((src, index) => (
              <SwiperSlide key={index} className="relative">
                <img
                  alt={`Slide ${index + 1}`}
                  src={src}
                  className="w-full h-auto max-h-[500px] object-cover rounded-xl"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
